/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { courseData } from "../constant/dummyData";
import Course from "./Course";
const Courses = () => {
  return (
    <div className=" section-padding" id="services-section">
      <div className="container">
        <div className="text-center">
          <div className="mini-title">Popular Services</div>
          <div className="column-title ">
            Choose Our Top <span className="shape-bg">Services</span>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] pt-10">
          {courseData.map(
            (course, index) =>
              index < 6 ?<Course course={course} key={index} index={index} />:null
          )}
        </div>
      </div>
    </div>
  );
};

export default Courses;
